var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 0.431,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e2e8f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#717478"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_613",
    "data-name": "Rectangle 613",
    width: 54,
    height: 54,
    rx: 27,
    transform: "translate(19 396)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2443",
    "data-name": "Group 2443",
    transform: "translate(-17 -719)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 54,
    height: 54,
    rx: 27,
    transform: "translate(17 719)",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_24",
    "data-name": "Mask Group 24",
    transform: "translate(-2 323)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1994",
    "data-name": "Group 1994",
    transform: "translate(-42.608 -25.229)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4296",
    "data-name": "Path 4296",
    d: "M-141.684,430s-8.743,8.467-18.177,8.467-19.019-7.986-19.019-7.986c1.29-7.681,5.436-12.156,16.685-12.737C-148.012,417.009-142.97,422.6-141.684,430Z",
    transform: "translate(249.297 34.717)",
    fill: "#e9e9e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4297",
    "data-name": "Path 4297",
    d: "M-130.631,354.463a9.8,9.8,0,0,1-9.75-9.8,9.79,9.79,0,0,1,9.9-9.783,9.791,9.791,0,0,1,9.68,9.866A9.8,9.8,0,0,1-130.631,354.463Z",
    transform: "translate(219.184 96.348)",
    fill: "#e9e9e9"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatar);
export default __webpack_public_path__ + "static/media/default_avatar.c017fb8a100a4086cf64d37b2c5d597b.svg";
export { ForwardRef as ReactComponent };